var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoStrategy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8775 113.269C32.9269 113.623 30.9162 113.193 29.2824 112.071C27.648 110.946 26.5284 109.219 26.1663 107.272L14.814 45.7667C14.4541 43.8171 14.8827 41.8009 16.0078 40.1666C17.1296 38.53 18.8566 37.4077 20.8079 37.0419L73.4463 27.3261C75.3996 26.9712 77.4135 27.4031 79.0484 28.5309C80.68 29.6564 81.8001 31.3867 82.16 33.3363L93.5123 94.8418C93.869 96.7891 93.4398 98.8025 92.3148 100.437C91.192 102.068 89.4644 103.188 87.5159 103.553L34.8775 113.269Z",
    fill: "#D0D9E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2388 91.6332C45.4155 88.1297 42.714 85.149 39.2083 84.9755C35.7053 84.8016 32.7218 87.5036 32.5511 91.0088C32.3772 94.5118 35.0787 97.4925 38.5844 97.6659C42.0874 97.8399 45.0681 95.1384 45.2388 91.6332Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6452 91.505C64.6325 88.6147 63.9027 84.6611 61.0146 82.6706C58.1243 80.6834 54.1679 81.4137 52.1775 84.3017C50.1876 87.1925 50.9173 91.1462 53.8081 93.1362C56.6989 95.1261 60.6553 94.3958 62.6452 91.505Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2857 84.7954C82.4623 81.2919 79.7608 78.3112 76.2551 78.1378C72.7521 77.9638 69.7714 80.6653 69.598 84.171C69.4241 87.674 72.1256 90.6547 75.6313 90.8281C79.1343 91.0021 82.115 88.3006 82.2857 84.7954Z",
    fill: "#064AD3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8879 87.2366L74.9649 82.2359L76.5546 81.9425C76.7236 81.9113 76.8987 81.9128 77.0657 81.9469C77.2332 81.9836 77.3926 82.0529 77.5347 82.1507C77.6768 82.2485 77.7984 82.3727 77.8926 82.5161C77.9872 82.6621 78.0506 82.8224 78.0818 82.9915C78.113 83.1605 78.111 83.3329 78.0747 83.5031C78.038 83.6706 77.9687 83.83 77.8709 83.9721C77.7731 84.1142 77.6489 84.2358 77.505 84.3272C77.3617 84.4214 77.1987 84.4853 77.0296 84.5165L74.5293 84.978",
    stroke: "black",
    strokeWidth: 0.663893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7642 86.2513L76.7355 85.8874",
    stroke: "black",
    strokeWidth: 0.663893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7736 71.8721C29.5309 71.9169 29.2815 71.8642 29.078 71.7242C28.8746 71.5841 28.7363 71.3699 28.6915 71.1273C28.6468 70.8846 28.6994 70.6352 28.8395 70.4317C28.9801 70.231 29.1937 70.09 29.4364 70.0452L77.1667 61.2354C77.4094 61.1906 77.6593 61.246 77.8623 61.3833C78.0658 61.5234 78.204 61.7376 78.2488 61.9802C78.2936 62.2229 78.2409 62.4723 78.1008 62.6758C77.9608 62.8793 77.7466 63.0175 77.5039 63.0623L29.7736 71.8721Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.204 70.9646C55.508 70.5394 57.0311 68.3269 56.6058 66.0228C56.1805 63.7188 53.968 62.1958 51.664 62.621C49.3627 63.0458 47.8369 65.2588 48.2622 67.5628C48.6875 69.8669 50.9027 71.3894 53.204 70.9646Z",
    fill: "#7698DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3532 52.9976C26.1132 53.0419 25.8634 52.9865 25.6571 52.8469C25.4542 52.7096 25.3154 52.4927 25.2712 52.2527C25.2264 52.0101 25.279 51.7607 25.4191 51.5572C25.5619 51.3532 25.7755 51.2123 26.0155 51.168L73.7458 42.3582C73.9885 42.3134 74.2384 42.3687 74.4419 42.5088C74.6454 42.6489 74.7836 42.863 74.8284 43.1057C74.8726 43.3457 74.8205 43.5978 74.6799 43.7985C74.5398 44.002 74.3262 44.143 74.0835 44.1878L26.3532 52.9976Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2099 49.5302C65.5112 49.1055 67.0342 46.893 66.6089 44.5889C66.1841 42.2876 63.9716 40.7646 61.6703 41.1894C59.3636 41.6151 57.8433 43.8271 58.268 46.1284C58.6933 48.4325 60.9031 49.956 63.2099 49.5302Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5154 62.0449H134.614C138.984 62.0449 142.519 65.5801 142.519 69.9499V124.362C142.519 128.732 138.984 132.267 134.614 132.267H80.5154C76.1484 132.267 72.6104 128.732 72.6104 124.362V69.9499C72.6104 65.5801 76.1484 62.0449 80.5154 62.0449Z",
    fill: "#A0CFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0322 68.2144H131.448C134.165 68.2144 136.364 70.4132 136.364 73.1304V80.309C136.364 83.0263 134.165 85.2251 131.448 85.2251H82.0322C79.315 85.2251 77.1162 83.0263 77.1162 80.309V73.1304C77.1162 70.4132 79.315 68.2144 82.0322 68.2144Z",
    fill: "#064AD3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.023 98.5274L120.459 103.905L115.023 98.5274Z",
    fill: "#E4EAF0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.023 98.5274L120.459 103.905",
    stroke: "black",
    strokeWidth: 1.53592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.431 98.4964L115.055 103.935L120.431 98.4964Z",
    fill: "#E4EAF0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M120.431 98.4964L115.055 103.935",
    stroke: "black",
    strokeWidth: 1.53592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M101.266 98.6039L106.703 103.984L101.266 98.6039Z",
    fill: "#E4EAF0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101.266 98.6039L106.703 103.984",
    stroke: "black",
    strokeWidth: 1.53592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106.674 98.5755L101.27 104.033L106.674 98.5755Z",
    fill: "#E4EAF0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106.674 98.5755L101.27 104.033",
    stroke: "black",
    strokeWidth: 1.53592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M113.282 110.237L108.508 110.25L113.282 110.237Z",
    fill: "#E4EAF0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.282 110.237L108.508 110.25",
    stroke: "black",
    strokeWidth: 1.53592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStrategy);
export default __webpack_public_path__ + "static/media/NoStrategy.564d1d6ad7927b8a84be3a3b2a89e756.svg";
export { ForwardRef as ReactComponent };